<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <permission-guard :situation="situations.postListManagement">
          <router-link class="d-block mb-2" to="/admin/posts/post_groups">
            ← 記事グループ一覧に戻る
          </router-link>
          <div class="mb-3">
            <h2 class="title mb-3">
              {{
                groupRoles.find(
                  ({ value }) => value === this.$route.params.group_role
                ).text
              }}の設定
            </h2>
          </div>
          <template v-if="this.$route.params.group_role === 'ranking'">
            <editRanking
              :group-roles="groupRoles"
            ></editRanking>
          </template>
          <template v-else>
            <post-list-editor
              :group-role="this.$route.params.group_role"
            ></post-list-editor>
          </template>
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PermissionGuard from '@/components/commons/PermissionGuard'
import SituationUtils from '@/mixins/situation_utils'
import PostListEditor from './editor'
import editRanking from './editRanking'

export default {
  components: { PermissionGuard, PostListEditor, editRanking },
  mixins: [SituationUtils],
  data () {
    return {
      groupRoles: [
        { text: 'ピックアップ', value: 'pick_up' },
        { text: 'ランキング', value: 'ranking' },
        { text: '新着記事', value: 'arrival' },
        { text: 'スライダー', value: 'slider' }
      ]
    }
  }
}
</script>
